import React, { useEffect, useState } from "react";
import "./PartyModal.scss";
import Modal from "../Modal";
import TextInput from "../TextInput";
import Dropdown from "../Dropdown";
import DatePicker from "../DatePicker";
import Button from "../Button";
// import PartyModalCarousel from "../PartyModalCarousel";
import XMark from "../../assets/images/x-mark.svg";
import CongratsImage from "../../assets/images/congrats.svg";
import { postPartyInfo } from "../../apis/backend_helper";

const ThanksModal = ({ setIsOpen }) => {
  const handleContactUs = () => {
    setIsOpen(false);
    setTimeout(
      () =>
        document
          ?.getElementById("contact")
          .scrollIntoView({ behavior: "smooth" }),
      500
    );
  };
  return (
    <div className="party_thanksModal">
      <div className="party_thanksModalTop">
        <img onClick={() => setIsOpen(false)} src={XMark} alt="cross" />
      </div>
      <img
        src={CongratsImage}
        className="party_thanksModalCongrats"
        alt="congrats"
      />
      <h3>Thank you for filling out the form</h3>
      <p>
        Provide a brief explanation of the next steps in the process (e.g. you
        will receive an email or a representative will contact you etc)
      </p>
      <Button onClick={() => setIsOpen(false)}>Back to the website</Button>
      <p>
        If you have any issues{" "}
        <span onClick={handleContactUs}> contact us</span>{" "}
      </p>
    </div>
  );
};

const Form = ({ setIsComplete }) => {
  const [data, setData] = useState({
    firstName: "",
    lastName: "",
    ageOfGuests: "",
    guestsAge: "",
    phone: "",
    email: "",
    eventDate: "",
  });
  const [decor, setDecor] = useState("");
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(false);
  const [decorError, setDecorError] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!decor) {
      setDecorError(true);
      return;
    }
    setLoading(true);
    let finalData = {
      ...data,
      eventDate: data.eventDate.toString(),
    };
    if (decor) {
      finalData = { ...finalData, decor };
    }
    if (activities.length) {
      finalData = { ...finalData, activities };
    }
    try {
      const res = await postPartyInfo(finalData);
      if (res?.ok) {
        setData({
          firstName: "",
          lastName: "",
          ageOfGuests: "",
          guestsAge: "",
          phone: "",
          email: "",
          eventDate: "",
        });
        setDecor("");
        setActivities([]);
        setIsComplete(true);
      }
    } catch (err) {
      console.log("err", err);
    } finally {
      setLoading(false);
    }
  };

  const handleActivityChange = (e) => {
    const value = e.target.value;
    if (activities.includes(value)) {
      setActivities((prev) => prev.filter((act) => act !== value));
      return;
    }
    if (activities.length) {
      setActivities((prev) => [prev[0], value]);
    } else {
      setActivities([e.target.value]);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="partyModal_form">
      {/* <h4>Room Hire</h4> */}
      <p>
        Creator Zone signature activities can be custom packaged for your next
        celebration! Select from our themes & choose the activities.
      </p>
      <h4>
        Themes
        <span className="error">*</span>
      </h4>
      <p>Select from the following themes & activities:</p>
      <div className="partyModal_formDecors">
        {[
          "Mermaid",
          "Magical Wizards",
          "Frozen Wonderland",
          "Super Hero",
          "Dinosaur",
          "Outer Space",
          "STEAM Party",
          "No Theme",
        ].map((d, i) => (
          <label key={i} name="decor">
            <input
              type="radio"
              value={d}
              onChange={(e) => {
                setDecor(e.target.value);
                if (e.target.value) {
                  setDecorError(false);
                }
              }}
              onClick={() => {
                if (decor === d) {
                  setDecor("");
                  setDecorError(true);
                }
              }}
              checked={decor === d}
            />
            {d}
          </label>
        ))}
        {decorError && (
          <span className="error">Please select one of the above option.</span>
        )}
      </div>
      {/* <h4>Food & Cake</h4>
      <p>BYO food and cake!</p> */}

      <h4>Activity Sets:</h4>
      {/* <small>
        <b>
          A host/hostess will be at the party guiding party goers through the
          activities!
        </b>
      </small> */}
      <p>Select all that apply:</p>

      <div className="partyModal_formActivities">
        {[
          "Science Explosion",
          "Slime",
          "Canvas & Paint",
          "DIY Bracelet Making",
          "3D Print Paintable",
          "Laser Cut Paintable",
          "STEM Kit (Cars, Planes, Robots)",
        ].map((act) => (
          <label>
            <input
              type="checkbox"
              value={act}
              checked={activities.includes(act)}
              onChange={handleActivityChange}
            />
            {act}
          </label>
        ))}
      </div>

      <p>Please fill out the party details below & submit</p>
      <div className="partyModal_formMain">
        <TextInput
          value={data.firstName}
          onChange={(e) =>
            setData((prev) => ({ ...prev, firstName: e.target.value }))
          }
          required
          label="First Name"
          placeholder="e.g. John"
        />
        <TextInput
          value={data.lastName}
          onChange={(e) =>
            setData((prev) => ({ ...prev, lastName: e.target.value }))
          }
          required
          label="Last Name"
          placeholder="e.g. Dowry"
        />
        <Dropdown
          value={data.ageOfGuests}
          onChange={(e) =>
            setData((prev) => ({ ...prev, ageOfGuests: e.target.value }))
          }
          label="Age of Guests"
          options={[
            {
              label: "Select age of guests",
              value: "",
            },
            {
              label: " 2-5 years old",
              value: " 2-5 years old",
            },
            {
              label: "5-10 years old",
              value: "5-10 years old",
            },
            {
              label: "11-13 years",
              value: "11-13 years",
            },
            {
              label: "Other",
              value: "Other",
            },
          ]}
          required
        />
        <TextInput
          value={data.guestsAge}
          onChange={(e) =>
            setData((prev) => ({ ...prev, guestsAge: e.target.value }))
          }
          required
          label="Guests age"
          placeholder="Enter a range"
        />
        <TextInput
          value={data.phone}
          onChange={(e) =>
            setData((prev) => ({ ...prev, phone: e.target.value }))
          }
          required
          label="Phone number"
          type="number"
          placeholder="+1 123 456 7890"
        />
        <TextInput
          value={data.email}
          onChange={(e) =>
            setData((prev) => ({ ...prev, email: e.target.value }))
          }
          required
          label="Email"
          type="email"
          placeholder="Add your email address"
        />

        <DatePicker
          selected={data.eventDate}
          onChange={(date) => setData((prev) => ({ ...prev, eventDate: date }))}
          label="Event date"
          placeholderText="e.g. mm/dd/yyyy"
          dateFormat="MM-dd-yyyy"
          required
        />
      </div>

      <Button disabled={loading} type="submit">
        {loading ? "Submitting..." : "Submit"}
      </Button>
    </form>
  );
};

const PartyModal = ({ isOpen, setIsOpen }) => {
  const [isComplete, setIsComplete] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      setTimeout(() => setIsComplete(false), 200);
    }
  }, [isOpen]);

  return (
    <Modal isOpen={isOpen} setIsOpen={setIsOpen}>
      {isComplete ? (
        <ThanksModal setIsOpen={setIsOpen} />
      ) : (
        <div className="partyModal">
          <div className="partyModal_top">
            <h3>Plan your party!</h3>
            <img onClick={() => setIsOpen(false)} src={XMark} alt="cross" />
          </div>
          <Form setIsComplete={setIsComplete} />
        </div>
      )}
    </Modal>
  );
};

export default PartyModal;
